import UpcomingAppointmentsList from './UpcomingAppointmentsList';

export default UpcomingAppointmentsList;
